import { useCallback, useEffect, useState } from "react";
import { useNotifications } from "../../notifications/NotificationManager.js";
import { useGamefacts } from "./GameFactContext.js";
import useFetch from "../../hooks/useFetch.js";
import useDelete from "../../hooks/useDelete.js";
import GameFactDTO from "../../DTO/GameFactDTO.js";
import { deleteV2Gamefact, postV2Gamefact } from "../../../api/index.js";
import { getUserProvider } from "../../../actions/auth.js";
import { Box, TextField, Typography } from "@mui/material";
import Button from "../Button.js";
import { useDebounce } from "../../hooks/useDebounce.js";
import { convertSecondsToTime, convertTimeToSeconds } from "../../helpers/dateHelper.js";

const GameFactModelSaisie = ({gameFactModel, ressource, ressourceParam, event, gamefacts, createGamefact, updateGamefact, deleteGamefact}) => {



    // gameFactModel maxOccurence 1 
    // gameFactsExisting = Array de longueur 0 ou 1 - impossible que ce soit +
    // On propose des bouton Toggle sur les value
    // Si le fait de jeu existe on selectionne par défaut, et on édite le fait de jeu
    // Si le fait de jeu n'existe pas, on selectionne rien par défaut et on crée le fait de jeu au clique
    // Déterminer la valeur sélectionnée initialement
  
    const { addNotification } = useNotifications();
  
    const [gamefactToUpdate, setGamefactToUpdate] = useState()
    const [activeGamefact, setActiveGamefact] = useState(undefined);
  
    ////////////////////////    GAMEFACT MANIPULATION    ///////////////////////////////////////
    const { data, error, fetchData : createOrUpdate } = useFetch(postV2Gamefact, [[gamefactToUpdate]]);
    const { isDeleting, error: deleteError, isDeleted, deleteData, setIsDeleted } = useDelete(deleteV2Gamefact, activeGamefact?._id);
  
    useEffect(() => {
  
      if(!gamefacts || !gamefacts.length)
        return
  
      const filteredGamefacts = gamefacts.filter(g => ressource && event && g.details.actor[event.type]?._id === ressource._id && g.event._id === event._id && gameFactModel.type.name === g.type.name)
  
      // TODO maxOccurrence > 1
      setActiveGamefact(filteredGamefacts[0])
  
    }, [gamefacts, ressource, event])
  
    useEffect(() => {
      if (!data || data.length === 0) return;
  
      // Mettez à jour l'état avec le nouvel ID du premier GameFact retourné
      const updatedGF = new GameFactDTO(data[0])
  
      if(activeGamefact){
        updateGamefact(updatedGF)
      }else{
        createGamefact(updatedGF)
      }
  
      // Envoyer une notif au service de notification
      /*addNotification({
        title: 'Edition d\'un fait de jeu',
        type: 'success',
        description: 'Votre fait de jeu '+ updatedGF?.type?.category +' a été édité  avec succès !',
        //link: getRootUrl() +'/live/'+data._id+'/calendar'
      });*/
    }, [data])
  
    //Effet pour gérer la post-suppression
    useEffect(() => {
      if (isDeleted) {
         // mise à jour de la vue après la suppression
         deleteGamefact(activeGamefact?._id)
         setIsDeleted(false)
  
  
          // Envoyer une notif au service de notification
        /*addNotification({
            title: 'Supression d\'un fait de jeu',
            type: 'success',
            description: 'Votre fait de jeu a été supprimé avec succès !',
            //link: getRootUrl() +'/live/'+data._id+'/calendar'
        });*/
      }
    }, [isDeleted]);
  
    useEffect(() => {
  
      if(!error)
          return
  
      // Envoyer une notif au service de notification
      addNotification({
          title: 'Edition d\'un fait de jeu',
          type: 'error',
          description: error.status + ' - ' + error.message,
      });
  
    }, [error])
  
     // Gérer l'erreur
     useEffect(() => {
      if (deleteError) {
        // Afficher un message d'erreur ou le traiter comme nécessaire
        console.error(deleteError.message);
      }
    }, [deleteError]);
  
    
  
    useEffect(() => {
      if(gamefactToUpdate)
        createOrUpdate()
  
    }, [gamefactToUpdate])
  
    if(!ressource || !event || !ressource._id)
      return <Typography width={"40%"} variant="subtitle2" fontSize="0.8em" textAlign={'center'}>-</Typography>
  
    return (
      <GameFactResolved activeGamefact={activeGamefact} event={event} ressource={ressource} ressourceParam={ressourceParam} gameFactModel={gameFactModel} setGamefactToUpdate={setGamefactToUpdate} deleteData={deleteData} />
    )
}


const GameFactResolved = ({activeGamefact, ressource, ressourceParam, event, gameFactModel, setGamefactToUpdate, deleteData}) => {

  const handleToggleGameFact = useCallback((value) => {
    // Si le même bouton est cliqué (toggle off), remettre à null, sinon mettre à jour avec la nouvelle valeur
    if(!activeGamefact || activeGamefact.type.value !== value) {
      const gameFactData = {
        _id : activeGamefact?._id,
        idName: gameFactModel.idName,
        name : gameFactModel.type.name,
        event : {_id : event._id},
        type : {
          ...gameFactModel.type,
          value,
        },
  
        details : {
          actor : {
            [ressourceParam] : {_id : ressource._id}
          },
          time : 0,
          period : 0,
          success : true
        },
  
        provider : getUserProvider()
      }
  
      //handle MAJ when no reloading page
      setGamefactToUpdate(new GameFactDTO(gameFactData))
    } else {
      deleteData()
    }
  }, [activeGamefact, ressource])

  

  const handleEdit = useCallback((value) => {


    if(gameFactModel.type.format === 'time' && gameFactModel.type.unit === 'ss'){
      value = convertTimeToSeconds(value)
    }

    const gameFactData = {
      _id : activeGamefact?._id,
      idName: gameFactModel.idName,
      name : gameFactModel.type.name,
      event : {_id : event._id},
      type : {
        ...gameFactModel.type,
        value,
      },

      details : {
        actor : {
          [ressourceParam] : {_id : ressource._id}
        },
        time : 0,
        period : 0,
        success : true
      },

      provider : getUserProvider()
    }

    //handle MAJ when no reloading page
    setGamefactToUpdate(new GameFactDTO(gameFactData))
    
  }, [activeGamefact, ressource])

  const {value, setValue, handleChange} = useDebounce(handleEdit)

  useEffect(() => {
    if(activeGamefact)
      setValue(gameFactModel.type.format === 'time' ? convertSecondsToTime(activeGamefact?.type?.value) : activeGamefact?.type?.value)
    else
        setValue(gameFactModel.type.format === 'time' ? '00:00:00' : '')

  }, [activeGamefact])

  return (
    <GamefactInput gameFactModel={gameFactModel} selectedValue={value} toggle={handleToggleGameFact} change={handleChange} onClick={() => console.log(ressource)}/>
  )
}

export const GamefactInput = ({gameFactModel, selectedValue, toggle, change, onClick}) => {

  if(gameFactModel.type.values && gameFactModel.type.values.length)
    return (
      <Box sx={{p : 0 , m : 0}}>
        {gameFactModel && gameFactModel.type.values.map((value, index)  => 
        <Button 
        key={`${value}-${index}`} 
        sx={{
          minWidth: 20,
          height: 20,
          m: 1,
          // Conditionnellement styliser le bouton actif
          backgroundColor: (selectedValue && selectedValue === value) ? 'primary.main' : 'lightgrey',
        }}
        onClick={() => toggle(value)}>
            {value.charAt(0).toUpperCase()}
        </Button>)}
      </Box>
    )

    return (
      <Box sx={{p : 0 , m : 1}}>
        <TextField
        onClick={onClick}
        inputProps={{
          "step": 1,
        }} type={gameFactModel.type.format} value={selectedValue} onChange={(e)=> change(e.target.value)}/>
      </Box>
    )
}


export default GameFactModelSaisie